import { render, staticRenderFns } from "./SettsAcc.vue?vue&type=template&id=1fb66ae8&scoped=true"
import script from "./SettsAcc.vue?vue&type=script&lang=js"
export * from "./SettsAcc.vue?vue&type=script&lang=js"
import style0 from "./SettsAcc.vue?vue&type=style&index=0&id=1fb66ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb66ae8",
  null
  
)

export default component.exports